<template>
    <VendorFollowUp></VendorFollowUp>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const VendorFollowUp = defineAsyncComponent(() =>
    import("../../components/Purchasing/VendorFollowUp.vue")
);

export default {
    name: "VendorFollowUp_Purchashing",
    components: { VendorFollowUp, AuthLayout },
};
</script>
